/* A guide's body: a reading column. */
.body {
  max-width: 720px;
  font-size: 16px;
  line-height: 1.75;
  color: var(--text-secondary);
}

.p {
  margin: 0 0 18px;
}

.h2 {
  margin: 40px 0 14px;
  font-family: var(--font-display);
  font-weight: 600;
  font-size: 30px;
  line-height: 1.1;
  color: var(--text);
}

.h3 {
  margin: 28px 0 10px;
  font-family: var(--font-display);
  font-weight: 600;
  font-size: 23px;
  line-height: 1.15;
  color: var(--text);
}

.list {
  margin: 0 0 20px;
  padding-left: 22px;
}

.item {
  margin-bottom: 8px;
  padding-left: 4px;
}

.item::marker {
  color: var(--accent);
}

.body strong {
  font-weight: 600;
  color: var(--text);
}

.link {
  color: var(--primary);
  text-decoration: underline;
  text-decoration-color: var(--accent);
  text-underline-offset: 3px;
}

.link:hover {
  text-decoration-color: currentColor;
}

.quote {
  margin: 0 0 20px;
  padding-left: 18px;
  border-left: 3px solid var(--accent);
  font-style: italic;
}

.figure {
  margin: 28px 0;
}

.image {
  display: block;
  width: 100%;
  height: auto;
  border-radius: var(--radius-card);
}

.caption {
  margin-top: 8px;
  font-size: 13px;
  color: var(--text-muted);
}

@media (min-width: 1024px) {
  .body {
    font-size: 17px;
  }

  .h2 {
    font-size: 34px;
  }
}
